// components
import {
    Card,
    CardContent, CardFooter,
    CardFooterItem
} from "shared/components/bulma/card";

// functions
import { titleCasePipe } from "shared/pipes";

// pipes
import { Ellipsis } from "shared/pipes/ellipsis";
import { DisplayDate } from "shared/pipes/display-date";
import { ClipboardCopy } from "shared/pipes/clipboard-copy";
import { IconButton } from "@material-ui/core";

const iconMap = (role) => {
    switch (role) {
        case 'admin':
            return 'fas fa-users-cog';
        case 'stylist':
            return 'fas fa-vest-patches';
        case 'return_manager':
            return 'fas fa-undo-alt';
        case 'customer_support':
            return 'fas fa-phone-alt';
        case 'buyer':
            return 'fas fa-shopping-cart';
        case 'packer':
            return 'fas fa-box-open';
        case 'sender':
            return 'fas fa-shipping-fast';
        case 'quality_check':
            return 'fas fa-magnifying-glass';
        case 'disabled':
            return 'fas fa-user-slash';
        default:
            return 'fas fa-question-circle';
    }
}

const EmployeeRoleTag = ({ employee }) => {
    const tagColor = employee.new ? 'is-primary' : 'is-primary';

    return (
        <span className={`tag ${tagColor} is-light`}>
            <span className="icon-text">
                <span className="icon">
                    <i className={iconMap(employee.role)}></i>
                </span>
                <span>
                    {employee.role ? titleCasePipe.transform(employee.role) : 'Not Assigned'}
                </span>
            </span>
        </span>
    )
};
const RenderDate = ({ employee }) => {
    if (!employee.created_at) {
        return '...';
    };
    return (
        <DisplayDate>{employee.created_at}</DisplayDate>
    );
}

const EmployeeCard = ({ employee,HandleDelete }) => {
    const cardColor = employee.new ? 'has-background-primary-light' : '';

    return (
        <Card className={cardColor}>
            <CardFooter>
                <CardFooterItem>
                    <ClipboardCopy value={employee.id}>
                        <Ellipsis maxChars={15}>{`${employee.first_name} ${employee.last_name}`}</Ellipsis>
                    </ClipboardCopy>
                </CardFooterItem>

                <CardFooterItem className="has-text-info" path={`/closet-hackers/${employee.id}/style`}>
                    <EmployeeRoleTag employee={employee} />
                </CardFooterItem>
            </CardFooter>

            <CardContent>
                <p>
                    <span className="icon-text">
                        <span className="icon">
                            <i className="fas fa-envelope"></i>
                        </span>
                        <span>
                            {employee.email ? employee.email : '...'}
                        </span>
                    </span>
                </p>
                <p>
                    <RenderDate employee={employee} />
                </p>
                <IconButton
                    
                          onClick={() => HandleDelete(employee.id)}
                        >
                          <img
                            src="/delete.svg"
                            style={{ width: '19px' }}
                            alt=""
                          />
                        </IconButton>
            </CardContent>
        </Card>
    );
};

export { EmployeeCard };
